module.exports = __webpack_public_path__ + "static/img/download-weixin.89372a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download-weixin.jpg
// module id = 9nf4
// module chunks = 1